import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CycleTVODal } from '../dal/cycleTVO.dal';
import { CycleTVO } from '../models/cycleTVO.model';

@Injectable({
  providedIn: 'root',
})
export class CycleTVOService {
  public newCycleTVO: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private cycleDAL: CycleTVODal) {}

  updateNewCycleTVO(cycle: string | null) {
    this.newCycleTVO.next(cycle);
  }

  getCyclesTVO(): Observable<any[]> {
    return this.cycleDAL.getCyclesTVO();
  }

  createCycleTVO(tvo: CycleTVO): Observable<any[]> {
    return this.cycleDAL.createCycleTVO(tvo);
  }

  createCycleTVOFromSource(tvo: CycleTVO, originId: string): Observable<any[]> {
    return this.cycleDAL.createCycleTVOFromSource(tvo, originId);
  }

  updateCycleTVO(tvoId: string, tvo: CycleTVO): Observable<CycleTVO> {
    return this.cycleDAL.updateCycleTVO(tvoId, tvo);
  }

  deleteCycleTVO(tvoId: string): Observable<any[]> {
    return this.cycleDAL.deleteCycleTVO(tvoId);
  }

  generateSO(option: any): Observable<any[]> {
    return this.cycleDAL.generateSO(option);
  }

  copyWeek(tvo: string, from: number, to: number): Observable<any[]> {
    return this.cycleDAL.copyWeek(tvo, from, to);
  }

  copyFixNeeds(tvo: string, from: number, to: number): Observable<any[]> {
    return this.cycleDAL.copyFixNeeds(tvo, from, to);
  }

  updateCycleTVOComments(cycleTVOId: string, comments: string[]): Observable<CycleTVO> {
    return this.cycleDAL.updateCycleTVOComments(cycleTVOId, comments);
  }

  clear() {
    this.newCycleTVO.complete();
    this.newCycleTVO = new BehaviorSubject<string | null>(null);
  }
}
